// extracted by mini-css-extract-plugin
module.exports = {"no-results":"no-result_no-results__3GH6s"};